import avatarImage from "../img/avatar.jpeg";
import { DocumentList } from "../components/DocumentList";
import { Link, NavLink, useNavigate } from "react-router";
import ButtonBars from "../components/ButtonBars";
import PromotionCards from "../components/PromotionCards";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../context/AuthContext";
import image from "../img/home.png"
import useAxiosRequests from "../hooks/useAxiosRequest";
import ExternalRoutes from "../config/ExternalRoutes";
import { API_BASE_URL } from "../config/BaseUrl";
import { CircularProgress } from "@mui/material";
import { MessageContext } from "../context/MessageContext";

const Dashboard = () => {
    const { userInfo, conUserSubscribe } = useContext(AuthContext);
    const { sendRequest } = useAxiosRequests();
    const [documents, setDocuments] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const baseUrl = API_BASE_URL;
    const [loading, setLoading] = useState(true);
    const { showError, showSuccess } = useContext(MessageContext);

    const fetchDocuments = useCallback(async () => {
        try {
            const response = await sendRequest({ method: "GET", url: ExternalRoutes.document.list_by_user + userInfo.id })

            if (response) {
                setDocuments(response.member);
                setTotalItems(response.totalItems);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }

    }, [sendRequest, userInfo.id])

    const fetchUserSubscribe = async () => {
        try {
            const response = await sendRequest({ method: "GET", url: ExternalRoutes.subscription.by_user })
            if (response) {
                conUserSubscribe(response)
            }
        } catch (error) {
        }
    }


    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const params = queryParams.get('canceled');
        const success = queryParams.get('pm');
        if (success) {
            showSuccess("Vous êtes actuellement en mode gratuit.");
        }
        if (params) {
            showError("Paiement annulé");
        }
    }, [])

    useEffect(() => {
        if (userInfo) {
            fetchDocuments();
            fetchUserSubscribe();
        }
    }, [userInfo]);

    const buttonBarsRef = useRef();

    const openPopup = () => {
        buttonBarsRef.current?.open();
    };
    const navigate = useNavigate();
    const handleGoToHistory = () => {
        navigate("/history");
    };

    return (<>
        <section className="kl-dashboard">
            <div className="kl-header-dashboard">
                <div className="kl-dashboard-header">
                    <NavLink className="kl-link-to" to="/customer">
                        <div className="kl-info-customer">
                            <img
                                alt="Remy Sharp"
                                src={userInfo?.photo ? `${baseUrl}${userInfo.photo}` : avatarImage}
                                className="kl-image-avatar"
                                onError={(e) => {
                                    e.target.src = avatarImage;
                                }}
                            />
                            <div className="kl-info-header">
                                <span>Bienvenue 🖐</span>
                                <strong>{userInfo?.firstName || "Votre nom"} <span>{userInfo?.usrType && (
                                    ' , ' + (userInfo.usrType === 1 ? 'Taxi' : userInfo.usrType === 2 ? 'VTC' : '')
                                )}</span></strong>
                            </div>
                        </div>
                    </NavLink>
                    <div className="kl-dashboard-faStar">
                        <Link className="kl-see-more-button" to="/subscription-list">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.15327 2.33977L10.3266 4.68643C10.4866 5.0131 10.9133 5.32643 11.2733 5.38643L13.3999 5.73977C14.7599 5.96643 15.0799 6.9531 14.0999 7.92643L12.4466 9.57977C12.1666 9.85977 12.0133 10.3998 12.0999 10.7864L12.5733 12.8331C12.9466 14.4531 12.0866 15.0798 10.6533 14.2331L8.65994 13.0531C8.29994 12.8398 7.70661 12.8398 7.33994 13.0531L5.34661 14.2331C3.91994 15.0798 3.05327 14.4464 3.42661 12.8331L3.89994 10.7864C3.98661 10.3998 3.83327 9.85977 3.55327 9.57977L1.89994 7.92643C0.926606 6.9531 1.23994 5.96643 2.59994 5.73977L4.72661 5.38643C5.07994 5.32643 5.50661 5.0131 5.66661 4.68643L6.83994 2.33977C7.47994 1.06643 8.51994 1.06643 9.15327 2.33977Z" fill="#6F19FD" />
                            </svg>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
        <PromotionCards />
        <section style={{ background: "#fff" }} className="kl-document-list-with-type">
            {loading ? (
                <div className='kl-nothing-data'>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    {totalItems > 0 ? (
                        <>
                            <div className="kl-header-list-doc">
                                <div className="kl-text-icon-start">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" fill="#292D32" />
                                        <path d="M15.7096 15.93C15.5796 15.93 15.4496 15.9 15.3296 15.82L12.2296 13.97C11.4596 13.51 10.8896 12.5 10.8896 11.61V7.51001C10.8896 7.10001 11.2296 6.76001 11.6396 6.76001C12.0496 6.76001 12.3896 7.10001 12.3896 7.51001V11.61C12.3896 11.97 12.6896 12.5 12.9996 12.68L16.0996 14.53C16.4596 14.74 16.5696 15.2 16.3596 15.56C16.2096 15.8 15.9596 15.93 15.7096 15.93Z" fill="#292D32" />
                                    </svg>
                                    <span>Historique</span>
                                </div>
                                <button onClick={handleGoToHistory}>Voir plus</button>
                            </div>
                            <div className="kl-document-list-dashboard">
                                {documents.map((doc, key) => {
                                    return <DocumentList key={key} document={doc} type={doc?.conDocumentStatus?.docStName} />
                                })}
                            </div>
                        </>
                    ) : (
                        <div className="kl-nothing-doc">
                            <div className="kl-content-document-list">
                                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                                <img src={image} alt="image dashboard" />
                            </div>
                            <div className="kl-document-content">
                                <h2>Aucune document dans votre coffre</h2>
                                <p>Ajouter votre premier document en cliquant sur le bouton
                                    <button onClick={openPopup} className="kl-button-add-file">
                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.5 0.25C3.05625 0.25 0.25 3.05625 0.25 6.5C0.25 9.94375 3.05625 12.75 6.5 12.75C9.94375 12.75 12.75 9.94375 12.75 6.5C12.75 3.05625 9.94375 0.25 6.5 0.25ZM9 6.96875H6.96875V9C6.96875 9.25625 6.75625 9.46875 6.5 9.46875C6.24375 9.46875 6.03125 9.25625 6.03125 9V6.96875H4C3.74375 6.96875 3.53125 6.75625 3.53125 6.5C3.53125 6.24375 3.74375 6.03125 4 6.03125H6.03125V4C6.03125 3.74375 6.24375 3.53125 6.5 3.53125C6.75625 3.53125 6.96875 3.74375 6.96875 4V6.03125H9C9.25625 6.03125 9.46875 6.24375 9.46875 6.5C9.46875 6.75625 9.25625 6.96875 9 6.96875Z" fill="#254EDB" stroke="#292D32" strokeWidth="0.1875" />
                                        </svg>
                                    </button>
                                </p>
                            </div>
                        </div>
                    )}
                </>
            )}
        </section>
        <ButtonBars ref={buttonBarsRef} />
    </>);
};

export default Dashboard;
